import React from 'react'
import 'antd/lib/date-picker/style/index.css'
import moment from 'moment'
import { DatePicker } from 'antd'

const { RangePicker } = DatePicker

const FilterUpdateAt = ({ handleChangeDate, updated }) => {
    let timeout = 0

    const _handleDateChange = async (date, dateString) => {
        const [from, to] = dateString

        if (timeout) {
            clearTimeout(timeout)
        }

        if (typeof handleChangeDate === 'function') {
            const filters = Object.assign({}, updated)

            filters.update_at = {
                from,
                to
            }

            if (!to && !from) {
                delete filters.update_at
            }

            await handleChangeDate(filters)
        }
    }

    return (
        <div className='FilterUpdateAt'>
            <RangePicker
                placeholder={['Start date', 'End date']}
                value={[updated.update_at !== undefined ? moment(updated.update_at.from, 'YYYY-MM-DD') : '', updated.update_at !== undefined ? moment(updated.update_at.to, 'YYYY-MM-DD') : '']}
                ranges={{
                    'Today': [moment(), moment()],
                    'Last 7 Days': [moment().subtract(6, 'day'), moment()],
                    'This Month': [moment().startOf('month'), moment().endOf('month')],
                }}
                format={'YYYY-MM-DD'}
                onChange={_handleDateChange}
                className="w-100"
            />
        </div>
    )
}

export default FilterUpdateAt